// @flow

import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import { get, isNull } from "lodash";
import Modal from "react-responsive-modal";
import { Form, reduxForm, clearSubmitErrors } from "redux-form";
import { getClassName } from "ui-kit/utils/component";
import { Page } from "components";
import { Button } from "ui-kit/components";
import {
  sumbitSendInvest,
  cancelWithdraw,
  sumbitPerformWithdraw,
  clearErrorMessageFromUser,
  goToDashboardPage
} from "ducks/user/actions";
import DateHelper from "utils/date";
import CurrencySelector from "../../components/currencySelector";
import CurrencyForm from "./form";
import CancelDeposit from "./cancelDeposit/CancelDeposit";

import "./Withdraw.scss";

export const ccn = getClassName("Withdraw");

type StateProps = {
  authorized: boolean
};

class Withdraw extends Component {
  state = {
    modal: false,
    errorModal: false,
    cancel: false,
    value: 0,
    invalid: true,
    currency: "USD"
  };

  closeModal = () => this.setState({ modal: false });
  closeErrorModal = () => {
    this.setState({ errorModal: false });
    this.props.clearSubmitErrors('withdraw-form');
  };

  openModal = () => this.setState({ modal: true });
  openErrorModal = () => this.setState({ errorModal: true });

  componentDidUpdate(prevProps, prevState) {
    if(!prevState.errorModal && this.props.error === '512') {
      this.openErrorModal();
    }

    if (
      prevProps.user &&
      prevProps.user.invest &&
      this.props.user &&
      this.props.user.invest &&
      prevProps.user.invest.amount !== this.props.user.invest.amount
    ) {
      this.props.goToDashboardPage();
    }
  }

  onCurrencyChange = (currency) => {
    this.props.change("currency", currency);
    this.setState({ currency });
  };

  handleInputChange = e => {
    const { user } = this.props;

    let value = e.target.value.replace(/\D/g, "");

    // clear value if NaN detected (means restricted symbols were used)
    if (isNaN(value)) {
      value = "";
    }
    // for limitating int part to 3 digits
    if (parseInt(value, 10) > 100) {
      value = value.slice(0, -1);
    }

    this.setState({
      invalid: user.status !== "customer" || !parseFloat(e.target.value) || parseFloat(e.target.value) <= 0,
      value
    });
  };


  clearServerError = e => {
    const eTarget = e.target;
    if (Array.from(eTarget.parentNode.classList).includes("Input--invalid")) {
      eTarget.style.display = "none";
      eTarget.parentNode.classList.remove("Input--invalid");
    }
  };

  confirmCancelWithdraw = () => {
    this.setState({ cancel: true, modal: true });
  };

  hideConfirmCancelWithdraw = () => {
    this.closeModal();
    setTimeout(() => this.setState({ cancel: false }), 500);
  };

  cancelWithdraw = () => {
    this.hideConfirmCancelWithdraw();
    this.props.cancelWithdraw();
  };

  handleSubmit = (data, dispatch) => {
    this.closeModal();
    return sumbitPerformWithdraw(data, dispatch);
  };

  render() {
    const {
      modal,
      errorModal,
      cancel,
      invalid,
      value,
      currency
    } = this.state;

    const { handleSubmit, user, intl, loader } = this.props;
    const withdrawal = user ? user.withdrawal : null;

    const userBalanceValue = get(user, "balance.balance", null) !== null
      ? parseFloat(user.balance.balance)
      : null;

    const userBalanceDate = get(user, "balance.date", null);

    return (
      <Page loader={loader}>
        {userBalanceValue > 0 ? (
          <Form
            name="withdraw-form"
            onSubmit={handleSubmit(sumbitPerformWithdraw)}
            className={ccn("container")}
          >
            <Fragment>
              <h1 className={ccn("title")}>
                <FormattedMessage id="hbc.withdraw.title" defaultMessage="Withdraw"/>
              </h1>
              <p>
                <FormattedMessage id="hbc.withdraw.select" defaultMessage="Select asset to withdraw:"/>
              </p>
              <div className={ccn("row")}>
                <CurrencySelector
                  onChange={this.onCurrencyChange}
                  currency={currency}
                  dataForFormattedMessage={{ id: "hbc.withdraw.title", default: "Withdraw" }}
                />
              </div>
              <p className={ccn("row__percentage")}>
                <FormattedMessage id="hbc.withdraw.percentage" defaultMessage="Enter percentage to withdraw:"/>
              </p>
              {!isNull(userBalanceValue) && (
                <p className={ccn("row__balance")}>
                  {intl.formatMessage({
                    id:             "hbc.withdraw.your.balance",
                    defaultMessage: "Your balance {AmountAndCurrency} as of {someDefDate}"
                  }, {
                    AmountAndCurrency: `${userBalanceValue.toLocaleString("en-US", { minimumFractionDigits: 2 })} USD`,
                    someDefDate: new DateHelper(userBalanceDate).format("mm/dd/yyyy hh:MM")
                  })}
                </p>
              )}
              <CurrencyForm
                invalid={invalid}
                invest={this.openModal}
                clearServerError={this.clearServerError}
                onInputChange={this.handleInputChange}
                setValue={value}
              />
              {get(withdrawal, "date") && (
                <p className={ccn("row__processed")}>
                  {intl.formatMessage({
                    id: "hbc.withdraw.processed",
                    defaultMessage: "Your withdrawal will be processed at {someDefDate}"
                  }, {
                    someDefDate: withdrawal.date
                                   ? new DateHelper(withdrawal.date).addDays(1).setTime(0, 0).format("dd/mm/yyyy HH:MM:ss")
                                   : null
                  })}
                </p>
              )}
              <p className={ccn("row__tos")}>
                <FormattedMessage
                  id="hbc.withdraw.added.to.waitlist.two"
                  defaultMessage="Withdrawals are subject to asset conversion costs. Please see "
                />
                <a href="https://support.hedgedbitcoin.com/hc/en-us/articles/360018818751">
                  <FormattedMessage
                    id="hbc.withdraw.added.to.waitlist.two.tos"
                    defaultMessage="Terms of Service"
                  />
                </a>
                <FormattedMessage
                  id="hbc.withdraw.added.to.waitlist.two.and"
                  defaultMessage=" and "
                />
                <a href="https://support.hedgedbitcoin.com/hc/en-us/sections/360002645552-Deposits-and-Withdrawals">
                  <FormattedMessage
                    id="hbc.withdraw.added.to.waitlist.two.faq"
                    defaultMessage="FAQ"
                  />
                </a>
                .
              </p>
              <div className={ccn("btn-row")}>
                <Button
                  onClick={this.confirmCancelWithdraw}
                  className="Button--withdraw--cancel"
                  disabled={!withdrawal}
                >
                  <FormattedMessage
                    id="hbc.withdraw.cancel"
                    defaultMessage="cancel"
                  />
                </Button>
              </div>
            </Fragment>

            <Modal
              classNames={{ overlay: ccn("modal"), modal: ccn("modal-body") }}
              open={modal}
              onClose={this.closeModal}
            >
              {cancel && (
                <Fragment>
                  <h1>
                    <FormattedMessage
                      id="hbc.withdraw.cancel.deposit"
                      defaultMessage="Withdraw"
                    />
                  </h1>
                  <h2>
                    <FormattedMessage
                      id="hbc.withdraw.cancel.deposit.message"
                      defaultMessage="Cancel withdrawal?"
                    />
                  </h2>
                  <div className={ccn("btn-row")}>
                    <Button
                      className="Button--ok-no"
                      onClick={this.cancelWithdraw}
                    >
                      <FormattedMessage id="hbc.withdraw.cancel.deposit.ok" defaultMessage="ok" />
                    </Button>
                    <Button
                      className="Button--ok-no"
                      onClick={this.hideConfirmCancelWithdraw}
                    >
                      <FormattedMessage id="hbc.withdraw.cancel.deposit.no" defaultMessage="no" />
                    </Button>
                  </div>
                </Fragment>
              )}
              {!cancel && (
                <Fragment>
                  <h1>
                    <FormattedMessage
                      id="hbc.withdraw.withdraw.deposit"
                      defaultMessage="Withdraw"
                    />
                  </h1>
                  <h2>
                    <FormattedMessage
                      id="hbc.withdraw.withdraw.deposit.message"
                      defaultMessage="Do you really want to withdraw your asset?"
                    />
                  </h2>
                  <div className={ccn("btn-row")}>
                    <Button
                      className="Button--red Button--ok-no"
                      onClick={handleSubmit(this.handleSubmit)}
                    >
                      <FormattedMessage id="hbc.withdraw.withdraw.deposit.ok" defaultMessage="ok"/>
                    </Button>
                    <Button className="Button--ok-no" onClick={this.closeModal}>
                      <FormattedMessage id="hbc.withdraw.withdraw.deposit.no" defaultMessage="no"/>
                    </Button>
                  </div>
                </Fragment>
              )}
            </Modal>
          </Form>
        ) : (
          <CancelDeposit />
        )}
        <Modal
          classNames={{ overlay: ccn("modal"), modal: ccn("modal-body") }}
          open={errorModal}
          onClose={this.closeErrorModal}
        >
          <Fragment>
            <h1>
              <FormattedMessage
                id="hbc.withdraw.withdraw.deposit"
                defaultMessage="Withdraw"
              />
            </h1>
            <h2>
              <FormattedMessage
                id="hbc.withdraw.withdraw.deposit.error.small"
                defaultMessage="Withdrawal amount is too small"
              />
            </h2>
            <div className={ccn("btn-row")}>
              <Button className="Button--ok-no" onClick={this.closeErrorModal}>
                <FormattedMessage id="hbc.withdraw.withdraw.deposit.ok" defaultMessage="ok"/>
              </Button>
            </div>
          </Fragment>
        </Modal>
      </Page>
    );
  }
}

const mapStateToProps = ({ user }): StateProps => {
  return {
    user: user.info,
    loader: user.loader,
    errorObj: user.error,
    initialValues: user.info ? {
      amount: get(user, "info.invest.amount", 0),
      currency: get(user, "info.invest.currency", "USD")
    } : {}
  };
};

const WithdrawForm = reduxForm({
  form: "withdraw-form",
  enableReinitialize: true
})(Withdraw);

export default withRouter(connect(
  mapStateToProps,
  {
    sumbitSendInvest,
    cancelWithdraw,
    sumbitPerformWithdraw,
    clearErrorMessageFromUser,
    goToDashboardPage,
    clearSubmitErrors
  }
)(injectIntl(WithdrawForm)));



// WEBPACK FOOTER //
// ./src/containers/withdraw/Withdraw.js